import { render, staticRenderFns } from "./QuoteTemplateTags.vue?vue&type=template&id=5a591b2c&scoped=true"
import script from "./QuoteTemplateTags.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateTags.vue?vue&type=script&lang=js"
import style0 from "./QuoteTemplateTags.vue?vue&type=style&index=0&id=5a591b2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a591b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a591b2c')) {
      api.createRecord('5a591b2c', component.options)
    } else {
      api.reload('5a591b2c', component.options)
    }
    module.hot.accept("./QuoteTemplateTags.vue?vue&type=template&id=5a591b2c&scoped=true", function () {
      api.rerender('5a591b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quotetemplate/QuoteTemplateTags.vue"
export default component.exports